/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Credits_SubmittingInputs */

const en_admin_users_credits_submitting = /** @type {(inputs: Admin_Users_Credits_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitting...`)
};

/**
* | output |
* | --- |
* | "Submitting..." |
*
* @param {Admin_Users_Credits_SubmittingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_users_credits_submitting = /** @type {((inputs?: Admin_Users_Credits_SubmittingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Credits_SubmittingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_users_credits_submitting(inputs)
});
export { admin_users_credits_submitting as "admin.users.credits_submitting" }